module.exports = __webpack_public_path__ + "8410aedaa2a5fa4642a5a5a45c87304a.jpg";